import React from 'react';

const FuturePage = () => {
	return (
<></>
	);
};

export default FuturePage;